import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { REVIEWS } from '@fiverr-private/gig_page_waypoint_navigation';
import { BQ_CLICKED_REVIEWS_RATINGS } from '../utils/bigQueryEvents';

export const useOnReviewsClick = () => {
    const { biEvents, sectionScroller } = useGigPageContext();

    const onReviewsClick = () => {
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_REVIEWS_RATINGS });
        biEvents.sendMixPanelEvent({ eventName: 'Gig Page - Gig Title - Reviews clicked' });
        sectionScroller.scroll({ sectionKey: REVIEWS, forceScroll: true });
    };

    return onReviewsClick;
};
